import { render, staticRenderFns } from "./UploadDocuments.vue?vue&type=template&id=b57ec62a&scoped=true&"
import script from "./UploadDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocuments.vue?vue&type=style&index=0&id=b57ec62a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57ec62a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VIcon,VImg})
